import React from "react";
export default function ErrorList(props) {
  var errors = props.errors;
  return /*#__PURE__*/React.createElement("div", {
    className: "panel panel-danger errors"
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel-heading"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "panel-title"
  }, "Errors")), /*#__PURE__*/React.createElement("ul", {
    className: "list-group"
  }, errors.map(function (error, i) {
    return /*#__PURE__*/React.createElement("li", {
      key: i,
      className: "list-group-item text-danger"
    }, error.stack);
  })));
}